<template>
  <div id="submit-contact" class="tw-mt-5 md:tw-mt-8 tw-px-4 md:tw-px-8">
    <v-form v-model="isValid">
      <v-text-field
          name="name"
          class="my-3"
          label="Name"
          type="text"
          v-model="name"
          :rules="[required('Name')]"
      ></v-text-field>
      <v-text-field
          name="phone"
          class="my-3 tw-mt-4"
          label="Mobile Number"
          type="text"
          v-model="mobile"
          :rules="[required('Mobile No.'), mobileFormat()]"
      ></v-text-field>

      <v-card-actions class="col-sm-6 tw-mt-5 offset-sm-3">
        <v-btn block large
               color="secondary"
               class="my-3 "
               :loading="loading"
               @click="submit"
               :disabled="!isValid"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-form>
  </div>
</template>

<script>
/* eslint-disable no-nested-ternary */

import validations from '@/utils/validations';
// import axios from 'axios';
// import { FB_RFQ_COMM, FB_RFQ_CYCLE, FB_RFQ_UNSUPPORTED } from '@/utils/const';
import { mapGetters } from 'vuex';

export default {
  name: 'SubmitContact',
  props: ['insuranceType'],
  data() {
    return {
      loading: false,
      mobile: '+254',
      name: '',
      ...validations,
      isValid: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['authenticatedUser', 'isAuthenticated']),
  },
  mounted() {
    this.name = this.isAuthenticated ? this.authenticatedUser.name : '';
    this.mobile = this.isAuthenticated ? this.authenticatedUser.phone_number : '+254';
  },
  methods: {
    submit() {
      this.loading = true;
      // const data = {
      //   first_name: this.name, last_name: '', product_c: this.insuranceType === 'moto' ? 'Motor Cycle' : this.insuranceType === 'commercial' ? 'Motor Commercial' : 'Motor Private - RFQ Not supported', phone_mobile: this.mobile,
      // };
      // eslint-disable-next-line no-unused-expressions
      // this.insuranceType === 'moto' ? this.$analytics.logEvent(FB_RFQ_CYCLE, data) : this.insuranceType === 'commercial' ? this.$analytics.logEvent(FB_RFQ_COMM, data) : this.$analytics.logEvent(FB_RFQ_UNSUPPORTED, data);
      // axios.post('https://dev.api.crm.apainsurance.ke/leads/new/clientportal', data)
      //   .then((response) => {
      //     this.loading = false;
      //     this.$toast.success(response.data.message, 'Success');
      //     this.$emit('contact-form-submitted');
      //   });
    },
  },
};
</script>
